(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bellary-cross-sell"] && !Shopify.designMode) return;
  try {
    /* ---------- Bellary Cross-Sell: Variantenwahl ----------
     Haelt nur die AUSWAHL fest und schreibt die Varianten-ID in das
     versteckte Feld. Das Hinzufuegen selbst macht die Theme-Komponente.

     ⚠️ Delegation am document, nicht pro Element: der Drawer wird nach jeder
     Warenkorbaenderung gemorpht — direkt gebundene Lauscher waeren danach weg. */
  (function () {
    function varianten(pos) {
      var el = pos.querySelector('[data-cs-varianten]');
      if (!el) return [];
      if (!el.dataset.gelesen) {
        try {
          el._liste = JSON.parse(el.textContent);
        } catch (e) {
          el._liste = [];
        }
        el.dataset.gelesen = '1';
      }
      return el._liste || [];
    }

    function auswahl(pos) {
      var gewaehlt = [];
      pos.querySelectorAll('[data-cs-opt][aria-pressed="true"]').forEach(function (b) {
        gewaehlt[parseInt(b.dataset.csOpt, 10)] = b.dataset.csWert;
      });
      return gewaehlt;
    }

    function abgleichen(pos) {
      var gewaehlt = auswahl(pos);
      var gruppenEl = pos.querySelectorAll('.bellary-cs__gruppe');
      var labels = pos.querySelectorAll('.bellary-cs__gruppenlabel');
      var gruppen = gruppenEl.length;
      var feld = pos.querySelector('input[ref="variantId"]');
      var knopf = pos.querySelector('[data-cs-absenden]');
      var hinweis = pos.querySelector('[data-cs-hinweis]');
      if (!feld || !knopf) return;

      /* ⚠️ RUNDE 46: benennen, was fehlt. Vorher blieb der Knopf einfach
         deaktiviert, ohne zu sagen warum — daran ist der Test gescheitert. */
      var fehlend = [];
      for (var i = 0; i < gruppen; i++) {
        if (!gewaehlt[i]) {
          fehlend.push(labels[i] ? labels[i].textContent.trim() : '');
        }
      }

      var treffer = null;
      if (!fehlend.length) {
        varianten(pos).some(function (v) {
          for (var i = 0; i < gruppen; i++) {
            if (v.o[i] !== gewaehlt[i]) return false;
          }
          treffer = v;
          return true;
        });
      }

      if (treffer) {
        feld.value = treffer.id;
        feld.disabled = false;
        knopf.disabled = false;
        if (hinweis) hinweis.textContent = '';
      } else {
        feld.value = '';
        feld.disabled = true;
        knopf.disabled = true;
        if (hinweis) {
          /* Zwei verschiedene Faelle, zwei verschiedene Saetze: es fehlt noch
             eine Wahl — oder alles ist gewaehlt, aber die Kombination gibt es
             nicht (im Datensatz stehen nur LIEFERBARE Varianten). */
          var tNochWaehlen = hinweis.dataset.textNochWaehlen || 'Noch wählen: ';
          var tUnd = ' ' + (hinweis.dataset.textUnd || 'und') + ' ';
          var tNichtVerfuegbar = hinweis.dataset.textNichtVerfuegbar || 'Diese Kombination ist gerade nicht verfügbar.';
          hinweis.textContent = fehlend.length
            ? tNochWaehlen + fehlend.join(tUnd)
            : tNichtVerfuegbar;
        }
      }
    }

    /* Startzustand herstellen: die Farbe ist serverseitig vorbelegt, also muss
       die Hinweiszeile von Anfang an die fehlende Groesse nennen.
       ⚠️ Auch nach jedem Morphen noetig — der Drawer wird bei jeder
       Warenkorbaenderung neu gerendert. */
    function alleAbgleichen() {
      document.querySelectorAll('[data-cs-pos]').forEach(abgleichen);
    }

    document.addEventListener('click', function (e) {
      var auf = e.target.closest('[data-cs-aufklapp]');
      if (auf) {
        var offen = auf.getAttribute('aria-expanded') === 'true';
        auf.setAttribute('aria-expanded', offen ? 'false' : 'true');
        var wahl = document.getElementById(auf.getAttribute('aria-controls'));
        if (wahl) wahl.hidden = offen;
        if (!offen) {
          var posAuf = auf.closest('[data-cs-pos]');
          if (posAuf) abgleichen(posAuf);
        }
        return;
      }

      var knopf = e.target.closest('[data-cs-opt]');
      if (!knopf) return;
      var pos = knopf.closest('[data-cs-pos]');
      if (!pos) return;
      /* Innerhalb einer Gruppe genau eine Wahl. */
      knopf.parentElement.querySelectorAll('[data-cs-opt]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === knopf ? 'true' : 'false');
      });
      abgleichen(pos);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', alleAbgleichen);
    } else {
      alleAbgleichen();
    }
    document.addEventListener('shopify:cart:lines-update', function (e) {
      var fertig = e && e.promise ? e.promise : Promise.resolve();
      fertig.then(alleAbgleichen).catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellary-massentabelle"] && !Shopify.designMode) return;
  try {
    const BELLARY_CM_TO_IN = 0.3937007874;
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-bellary-unit-select]');
      if (!select) return;
      const wrapper = select.closest('.bellary-massentabelle');
      if (!wrapper) return;
      const unit = select.value;
      wrapper.querySelectorAll('[data-cm]').forEach((cell) => {
        const cm = parseFloat(cell.dataset.cm);
        cell.textContent = unit === 'in' ? (cm * BELLARY_CM_TO_IN).toFixed(1) : cm;
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellary-newsletter-anchor"] && !Shopify.designMode) return;
  try {
    function bellaryPerformScroll() {
    var target = document.getElementById('newsletter');
    if (target) target.scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  function bellaryScrollToNewsletter() {
    if (location.hash !== '#newsletter') return;
    var cancelled = false;
    var cancel = function () {
      cancelled = true;
    };
    window.addEventListener('wheel', cancel, { once: true, passive: true });
    window.addEventListener('touchmove', cancel, { once: true, passive: true });
    window.addEventListener('keydown', cancel, { once: true });
    var attempts = 0;
    var tick = function () {
      if (cancelled) return;
      bellaryPerformScroll();
      attempts++;
      if (attempts < 30) setTimeout(tick, 200);
    };
    tick();
    window.addEventListener('load', function () {
      if (!cancelled) setTimeout(bellaryPerformScroll, 300);
    });
  }
  bellaryScrollToNewsletter();
  window.addEventListener('hashchange', bellaryScrollToNewsletter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellary-wishlist-button"] && !Shopify.designMode) return;
  try {
    const BELLARY_WISHLIST_KEY = 'bellary_wishlist';

  function bellaryReadWishlist() {
    try {
      const raw = localStorage.getItem(BELLARY_WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function bellaryWriteWishlist(ids) {
    try {
      localStorage.setItem(BELLARY_WISHLIST_KEY, JSON.stringify(ids));
    } catch (error) {
      /* localStorage nicht verfuegbar (z. B. privates Fenster) - Toggle bleibt rein visuell */
    }
  }

  function bellarySyncButton(button) {
    const ids = bellaryReadWishlist();
    const saved = ids.includes(button.dataset.productId);
    button.classList.toggle('bellary-wishlist-button--saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  document.querySelectorAll('[data-bellary-wishlist-toggle]').forEach(bellarySyncButton);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bellary-wishlist-toggle]');
    if (!button) return;
    const id = button.dataset.productId;
    const ids = bellaryReadWishlist();
    const index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    bellaryWriteWishlist(ids);
    bellarySyncButton(button);
    /* ⚠️ RUNDE 58: Meldung an assets/bellary-wunschliste.js — der Zaehler in
       Kopfzeile und Schublade und die Wunschlistenseite haengen daran.
       Bewusst ein AUSDRUECKLICHES Ereignis statt eines zweiten delegierten
       click-Handlers dort: die Reihenfolge zweier Handler an `document` haengt
       an der Ladereihenfolge der Dateien und ist nicht zugesichert — der
       Zaehler waere mal aktuell, mal einen Klick hinterher. */
    document.dispatchEvent(new CustomEvent('bellary:wunschliste'));
  });

  /* Runde 15 (25.8.2026): Herz auf der Produktseite neben statt unter
     "In den Warenkorb". Reines CSS/flex-wrap reicht nicht, weil das Herz im
     Markup ein Geschwister des GESAMTEN Kaufknopf-Blocks ist (der Block
     selbst enthaelt Mengenauswahl + Kaufknopf als eigene, verschachtelte
     Flex-Reihe "product-form-buttons--stacked"). Beim Umbruch auf schmalen
     Bildschirmen landet das Herz deshalb neben der MENGENAUSWAHL (die zuerst
     im Fluss steht und noch Platz in Zeile 1 hat), nicht neben dem
     Kaufknopf. buy-buttons ist eine native Horizon-Komponente ohne
     Custom-Liquid-Erweiterungspunkt (siehe blocks/buy-buttons.liquid,
     Schema ohne "blocks"-Feld) - das Herz laesst sich nicht per Liquid dort
     hineinrendern. Deshalb hier per JS an die richtige Stelle verschoben:
     als Geschwister von Mengenauswahl und Kaufknopf INNERHALB derselben
     Flex-Reihe. bellary-wishlist-button.liquid rendert auf jeder Produktseite
     garantiert vor diesem Script, Klick-Handling laeuft ueber Event-
     Delegation (oben) und ist unabhaengig von der DOM-Position. */
  function bellaryMoveWishlistIntoBuyRow() {
    const stacked = document.querySelector('.product-details .product-form-buttons--stacked');
    const wishlist = document.querySelector('.product-details .bellary-wishlist-button');
    if (!stacked || !wishlist || stacked.contains(wishlist)) return;
    stacked.appendChild(wishlist);
  }
  bellaryMoveWishlistIntoBuyRow();

  /* Vertrauenszeile (Versand/Rueckgabe/Zahlung) bekommt eine eigene Klasse,
     damit sie in bellary-store-styles.liquid gezielt gestylt werden kann -
     Horizons group-Bloecke tragen sonst nur generische, nicht eindeutige
     Klassen (kein data-Attribut mit dem Blocknamen im Markup). Ueber den
     Textinhalt erkannt, weil das der einzige zuverlaessige Anker ist. */
  function bellaryTagTrustRow() {
    document.querySelectorAll('.product-details .layout-panel-flex--row').forEach((row) => {
      if (row.classList.contains('bellary-trust-row')) return;
      /* ⚠️⚠️ RUNDE 56: Hier wurde die Zeile am DEUTSCHEN Text erkannt
         (`text.includes('Kostenlos') && text.includes('SSL-verschluesselt')`).
         Seit die Vertrauenszeile ueber 'bellary.vertrauenszeile' | t laeuft,
         griffe das auf /fr, /es, /it, /nl und /en nicht mehr — die Klasse
         bliebe aus und die Gestaltung fiele weg, ohne Fehlermeldung.
         Jetzt am Klassennamen erkannt, den das Markup ohnehin traegt. */
      if (row.querySelector('.bellary-vertrauenszeile')) {
        row.classList.add('bellary-trust-row');
      }
    });
  }
  bellaryTagTrustRow();

  /* Anker-Links auf der Seite (z. B. "Versand" unter dem Preis, "Groessenhilfe"
     neben der Groesse) sollen die passende details-Zeile automatisch aufklappen,
     nicht nur dorthin scrollen - native <details> tun das ohne Klick nicht von
     selbst. Hier statt in bellary-massentabelle.liquid untergebracht, weil
     dieser Button auf jeder Produktseite garantiert rendert (Massentabelle kann
     bei fehlenden Metafeldern leer bleiben). */
  function bellaryOpenTargetDetails() {
    if (!location.hash) return;
    const target = document.querySelector(location.hash);
    if (target && target.tagName === 'DETAILS') {
      target.open = true;
    }
  }
  bellaryOpenTargetDetails();
  window.addEventListener('hashchange', bellaryOpenTargetDetails);
  } catch(e) { console.error(e); }
})();

})();
